var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCardAccountDetailsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 30,
    viewBox: "0 0 31 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.523438,
    width: 30,
    height: 30,
    rx: 15,
    fill: "#EAEAEA"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_246_11296)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.0234 8.25H8.02344C7.20594 8.28 6.55344 8.9325 6.52344 9.75V20.25C6.55344 21.0675 7.20594 21.72 8.02344 21.75H23.0234C23.8409 21.72 24.4934 21.0675 24.5234 20.25V9.75C24.4934 8.9325 23.8409 8.28 23.0234 8.25ZM23.0234 20.25H8.02344V9.75H23.0234V20.25ZM17.0234 18.75V17.8125C17.0234 16.5675 14.5184 15.9375 13.2734 15.9375C12.0284 15.9375 9.52344 16.5675 9.52344 17.8125V18.75H17.0234ZM13.2734 11.25C12.7762 11.25 12.2992 11.4475 11.9476 11.7992C11.596 12.1508 11.3984 12.6277 11.3984 13.125C11.3984 13.3712 11.4469 13.615 11.5412 13.8425C11.6354 14.07 11.7735 14.2767 11.9476 14.4508C12.2992 14.8025 12.7762 15 13.2734 15C13.5197 15 13.7635 14.9515 13.991 14.8573C14.2185 14.763 14.4252 14.6249 14.5993 14.4508C14.7734 14.2767 14.9115 14.07 15.0057 13.8425C15.0999 13.615 15.1484 13.3712 15.1484 13.125C15.1484 12.8788 15.0999 12.635 15.0057 12.4075C14.9115 12.18 14.7734 11.9733 14.5993 11.7992C14.4252 11.6251 14.2185 11.487 13.991 11.3927C13.7635 11.2985 13.5197 11.25 13.2734 11.25ZM17.0234 11.25V12H21.5234V11.25H17.0234ZM17.0234 12.75V13.5H21.5234V12.75H17.0234ZM17.0234 14.25V15H20.0234V14.25H17.0234Z",
    fill: "#414042"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_246_11296"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white",
    transform: "translate(6.52344 6)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCardAccountDetailsIcon);
export default __webpack_public_path__ + "static/media/card-account-details-icon.69b632ffabf2e509e7ede1d743327969.svg";
export { ForwardRef as ReactComponent };